import { render, staticRenderFns } from "./prog-corr.vue?vue&type=template&id=04d8eff1"
import script from "./prog-corr.vue?vue&type=script&lang=js"
export * from "./prog-corr.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports